import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { ProductoService } from '../../_services/producto.service';
import { forkJoin, Observable } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { SegmentoActivo } from '../../_models/segmento-activo';
import { SegmentoActivoService } from '../../_services/segmento-activo.service';
import { SegmentoTipoContrato } from '../../_models/segmento-tipo-contrato';
import { SegmentoTipoContratoService } from '../../_services/segmento-tipo-contrato.service';

@Component( {
  templateUrl: 'segmento-tipo-contrato.component.html',
  selector: 'app-segmento-tipo-contrato',
  providers: [ ConfirmationService ]
} )
export class SegmentoTipoContratoComponent implements OnInit {
  @Input() detalle: boolean = false;
  columnas: any[];
  formulario: FormGroup;
  carSegmentoProducto: boolean;
  segmentoContratos: SegmentoTipoContrato[] = [];
  @Input()
  segmento: Segmento;
  @Input()
  segmentoTemp: any;
  submitted: boolean;
  guardando: boolean;
  listaTiposContratos: SelectItem[];
  allTiposContratos: ListaItem[];

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private segmentoTipoContratoService: SegmentoTipoContratoService,
               private productosService: ProductoService,
               private listaService: ListaService,
               private confirmacionServicio: ConfirmationService ) {
  }


  ngOnInit(): void {
    this.formulario = this.formBuilder.group( {
      idTipoContrato: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.columnas = [
      { field: 'nombreActivoSegmentacion', header: this.navServicio.buscarMensaje( 'SEGMENTOSACTIVOS.LBL_RANGOACTIVOS' ), sort: true }
    ];
    if ( !this.detalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }
    forkJoin( this.listaService.getMasterDetails('ListasTiposContratos'),
      this.segmentoTipoContratoService.obtenerPorSegmento( this.segmento.idSegmento ) ).subscribe( ( [ res1, res2 ] ) => {
      this.allTiposContratos = res1;
      this.segmentoContratos = res2;
      this.carDropdown();
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );
  }

  carDropdown(): void {
    this.listaTiposContratos = [];
    this.allTiposContratos.map( p => {
      if ( p.indicadorHabilitado && !this.segmentoContratos.find( sp => sp.indicadorHabilitado && sp.idTipoContrato === p.idLista ) ) {
        this.listaTiposContratos.push( { label: p.nombre, value: p.idLista } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get segContratos() {
    return this.segmentoContratos.filter( s => s.indicadorHabilitado );
  }

  onSubmit(): void {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carSegmentoProducto = true;
      const temp: SegmentoTipoContrato = this.formulario.value;
      temp.idSegmento = this.segmento.idSegmento;
      temp.nombreTipoContrato = this.allTiposContratos.find( p => p.idLista === temp.idTipoContrato ).nombre;
      const a = this.segmentoContratos.find( sp => sp.idTipoContrato === temp.idTipoContrato );
      if ( a ) {
        temp.idSegmentoTipoContrato = a.idSegmentoTipoContrato;
      }
      temp.indicadorHabilitado = true;
      if ( temp.idSegmentoTipoContrato ) {
        this.segmentoTipoContratoService.actualizar( temp ).subscribe( res => {
          const tempSegmentoP: SegmentoTipoContrato[] = this.segmentoContratos;
          this.segmentoContratos = [];
          tempSegmentoP.map( t => {
            if ( t.idSegmentoTipoContrato === temp.idSegmentoTipoContrato ) {
              t.indicadorHabilitado = true;
            }
          } );
          this.segmentoContratos = tempSegmentoP;
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 2 );
        } );
      } else {
        this.segmentoTipoContratoService.agregar( temp ).subscribe( res => {
          temp.idSegmentoTipoContrato = res.idSegmentoTipoContrato;
          this.segmentoContratos.push( temp );
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 1 );
        } );
      }
    } else {
      return;
    }
  }

  disable( row: SegmentoTipoContrato ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Tipo de contrato',
      icon: 'fa fa-question-circle',
      key: 'contrato',
      accept: () => {
        row.indicadorHabilitado = false;
        this.segmentoTipoContratoService.actualizar( row ).subscribe( res => {
          const temp: SegmentoTipoContrato[] = this.segmentoContratos;
          this.segmentoContratos = [];
          temp.map( t => {
            if ( t.idSegmentoTipoContrato === row.idSegmentoTipoContrato ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.segmentoContratos = temp;
          this.carDropdown();
        } );
      }
    });
  }
}
